import { useState, useEffect, useRef } from 'react';
import { store } from 'stores/Store';

export const useLocalStorageState = <T>(key: string, initialValue?: T): [T | undefined, React.Dispatch<React.SetStateAction<T | undefined>>] => {
  // Initialize state from store or initialValue
  const [value, setValue] = useState<T | undefined>(() => {
    try {
      // Check if there's already a value in the store
      const storedValue = store.getTemporaryNotes(key);
      console.log('Stored valueeeee:', storedValue);
      if (storedValue !== null && storedValue !== undefined) {
        // If there's already a value in store, use that
        console.log('Stored value:', storedValue);
        return storedValue as T;
      }
      // Only use initialValue if there's nothing in store
      return initialValue;
    } catch (error) {
      console.error('Error reading from store:', error);
      return initialValue;
    }
  });

  // Debounce timer ref
  const debounceTimerRef = useRef<NodeJS.Timeout>();

  // Save to store whenever value changes (with debounce)
  useEffect(() => {
    if (value !== undefined) {
      // Clear existing timer
      if (debounceTimerRef.current) {
        clearTimeout(debounceTimerRef.current);
      }
      
      // Set new timer for 2 seconds
      debounceTimerRef.current = setTimeout(() => {
        try {
          store.setTemporaryNotes(key, value);
          console.log('Saved to store:', key, value);
        } catch (error) {
          console.error('Error writing to store:', error);
        }
      }, 2000);
    }

    // Cleanup timer on unmount
    return () => {
      if (debounceTimerRef.current) {
        clearTimeout(debounceTimerRef.current);
      }
    };
  }, [value, key]);

  return [value, setValue];
};
